import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getAuth } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyDeLTYLJ_OWZ5gIraIoV60lqBuvb-UWwqs",
  authDomain: "c-template-aae46.firebaseapp.com",
  projectId: "c-template-aae46",
  storageBucket: "c-template-aae46.firebasestorage.app",
  messagingSenderId: "1067557135368",
  appId: "1:1067557135368:web:c2b5591f275becb2d75dbd",
  measurementId: "G-SYJPE5ZTQG",
};

// Initialize Firebase
export const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
export const storage = getStorage(app);
export const auth = getAuth(app);
